import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {ListBox} from "primereact/listbox";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {ClientService} from "../services/ClientService";
import {InputText} from "primereact/inputtext";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import Loader from "../components/Loader";
import {SelectButton} from "primereact/selectbutton";
import {Checkbox} from "primereact/checkbox";
import PhoneInput from "react-phone-input-2";
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {confirmPopup, ConfirmPopup} from "primereact/confirmpopup";
import {Badge} from "primereact/badge";
import {Image} from "primereact/image";
import {Avatar} from "primereact/avatar";
import {FileUpload} from "primereact/fileupload";
import {Dialog} from "primereact/dialog";
import {Message} from "primereact/message";
import {Chip} from "primereact/chip";
import {Tag} from "primereact/tag";
import {confirmDialog, ConfirmDialog} from "primereact/confirmdialog";
import {FinanceService} from "../services/FinanceService";

export default function Client() {

    const locationParams = useParams()
    const dispatch = useDispatch()
    const [client, setClient] = useState(false)

    const [tabs, setTabs] = useState([
        {label: 'Контакты', id: 'parents', icon: 'pi pi-users'},
        {label: 'Ребенок', id: 'children', icon: 'pi pi-user-edit'},
        {label: 'Документы', id: 'documents', icon: 'pi pi-file-edit'},
        {label: 'Детский клуб', id: 'contracts-kindergarten', icon: 'pi pi-tag'},
        {label: 'Доп. занятия', id: 'contracts-additional_class', icon: 'pi pi-tag'},
        {label: 'Индивидуальные', id: 'contracts-individual_lesson', icon: 'pi pi-tag'},
        {label: 'Летний лагерь', id: 'contracts-summer_camp', icon: 'pi pi-tag'},
        {label: 'Школа', id: 'contracts-school', icon: 'pi pi-tag'},
        {label: 'Платежи', id: 'payments', icon: 'pi pi-wallet'},
        {label: 'Комментарии и задачи', id: 'comments', icon: 'pi pi-comments'},
    ])
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [activeTab, setActiveTab] = useState(tabs[0])
    const [isLoaded, setIsLoaded] = useState(false)
    const [isNewClient, setIsNewClient] = useState(false)
    let navigation = useNavigate();

    const handleTabClick = (e, item) => {
        setActiveTab(e.target.value);
        navigation(e.value.id)
    }

    const updateData = () => {
        if (locationParams.clientId === 'create') {
            dispatch(setTitle('Новый клиент'))
            setIsNewClient(true)
            setIsLoaded(true)
        } else {
            setIsNewClient(false)
            dispatch(setTitle('Клиент #' + locationParams.clientId))
            ClientService.GetById(locationParams.clientId, '').then((result) => {
                dispatch(setTitle('Клиент #' + locationParams.clientId))
                // console.log(result)
                setClient({...result, ...{updateUser: updateData}})
                clientForm.setValues(result, false)
                setIsLoaded(true)
            })
        }
    }


    useEffect(() => {

        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
        dispatch(setCreateButton(false))

        updateData()

    }, []);

    useEffect(() => {
        updateData()
    }, [locationParams.clientId]);

    const clientForm = useFormik({
        initialValues: {
            name: ''
        },
        validate: (data) => {
            let errors = {}
            if (!data.name) {
                errors.name = 'Укажите имя'
            }

            return errors
        },
        onSubmit: (data) => {
            setIsLoaded(true)

            if(client) {
                ClientService.Update(client.id, data).then((r) => {
                    // setIsLoaded(false)
                    updateData()
                    navigation('/clients')
                })
            } else {
                ClientService.Create(data).then((r) => {
                    // setIsLoaded(false)
                    updateData()
                    navigation('/clients')
                })
            }
        }
    })


    return (
        <>
            <ConfirmPopup/>
            <ConfirmDialog/>


            <div className="row">


                    <div className="col-md-4">
                        <div className="card">


                            <div className="card-body edit-profile ">

                                <form onSubmit={clientForm.handleSubmit}>
                                    <FormGroup error={clientForm.errors.name} label={'Имя/название клиента'}>
                                        <InputText value={clientForm.values.name}
                                                   onChange={(e) => clientForm.setFieldValue('name', e.target.value)}/>
                                    </FormGroup>

                                    <Button type={'submit'} label={'Сохранить'} loading={!isLoaded}/>
                                </form>

                            </div>
                        </div>

                    </div>

                <div className="col-md-8">


                </div>
            </div>
        </>
    )
}